import { getPageUrl } from './index';
import { RouteObject } from 'react-router-dom';

//MenuWarehouse
import MenuWarehouseCategory from '../components/internal/menuWarehouse/MenuWarehouseCategory';
import MenuWarehouseType from '../components/internal/menuWarehouse/MenuWarehouseType';
import MenuWarehouse from '../components/internal/menuWarehouse/MenuWarehouse';
import MenuMovie from '../components/internal/menuWarehouse/MenuMovie';
import ExpandCategory from '../components/internal/menuWarehouse/ExpandCategory';
import ExpandType from '../components/internal/menuWarehouse/ExpandType';
import ExpandDetail from '../components/internal/menuWarehouse/ExpandDetail';
import Scene from '../components/internal/menuWarehouse/Scene';
import MenuWarehouseDepartment from '../components/internal/menuWarehouse/MenuWarehouseDepartment';
import CookMethod from '../components/internal/menuWarehouse/CookMethod';

//Finance
import InternalStatisticsCategory from '../components/internal/finance/InternalStatisticsCategory';
import InternalStatisticsType from '../components/internal/finance/InternalStatisticsType';
import InternalStatisticsSetting from '../components/internal/finance/InternalStatisticsSetting';

//MenuWarehouseArticle
import MenuWarehouseArticleCategory from '../components/internal/menuWarehouseArticle/MenuWarehouseArticleCategory';
import MenuWarehouseArticleType from '../components/internal/menuWarehouseArticle/MenuWarehouseArticleType';
import MenuWarehouseArticle from '../components/internal/menuWarehouseArticle/MenuWarehouseArticle';

//BranchStoreMenuWarehouse
import BranchStoreMenuWarehouse from '../components/internal/menu/BranchStoreMenuWarehouse';
import DimSumHistory from '../components/internal/menu/DimSumHistory';

//Ingredient
import IngredientWarning from '../components/internal/ingredient/IngredientWarning';

//other
import DeptPrintDetail from '../components/internal/menu/DeptPrintDetail';

//menu
import MenuBinding from '../components/internal/menu/MenuBinding';
import ShopCategory from '../components/internal/menu/ShopCategory';
import ShopType from '../components/internal/menu/ShopType';
import MenuHead from '../components/internal/menu/MenuHead';
import MenuMemo from '../components/internal/menu/MenuMemo';
import MenuCondiment from '../components/internal/menu/MenuCondiment';
import MenuShoppingCart from '../components/internal/menu/MenuShoppingCart';
import CondimentWarehouse from '../components/internal/menu/CondimentWarehouse';
import MenuHeadCode from '../components/external/code/MenuHeadCode';
import MenuLabel from '../components/internal/menu/MenuLabel';
import MenuOPLog from '../components/internal/menu/MenuOPLog';
import PromoCategory from '../components/internal/menu/PromoCategory';
import MenuSaleDate from '../components/internal/menu/MenuSaleDate';
import MenuSalePeriod from '../components/internal/menu/MenuSalePeriod';
import MenuSaleTime from '../components/internal/menu/MenuSaleTime';
import MenuSalesman from '../components/internal/menu/MenuSalesman';
import Icon from '../components/internal/menu/Icon';
import MenuIcon from '../components/internal/menu/MenuIcon';
import MenuHoliday from '../components/internal/menu/MenuHoliday';

//Inventory
import CondimentInventory from '../components/internal/menu/inventory/CondimentInventory';
import MenuSpecInventory from '../components/internal/menu/inventory/MenuSpecInventory';
import MenuSpeSpecInventory from '../components/internal/menu/inventory/MenuSpeSpecInventory';
import MenuImSpecInventory from '../components/internal/menu/imInventory/MenuImSpecInventory';
import ImMenuSpeSpecInventory from '../components/internal/menu/imInventory/ImMenuSpeSpecInventory';
import ImCondimentInventory from '../components/internal/menu/imInventory/ImCondimentInventory';

//feastTeam
// import FeastTeamMenu from '../components/internal/feastTeam/FeastTeamMenu';
import FeastTeamMenuWarehouse from '../components/internal/feastTeam/FeastTeamMenuWarehouse';
import FeastTeamMenuWarehouseCategory from '../components/internal/feastTeam/FeastTeamMenuWarehouseCategory';
import FeastTeamMenuHead from '../components/internal/feastTeam/FeastTeamMenuHead';

//reserveMenu
import ReserveMenuCategory from '../components/internal/reserveMenu/ReserveMenuCategory';
import ReserveMenu from '../components/internal/reserveMenu/ReserveMenu';
import ReserveMenuHistory from '../components/internal/reserveMenu/ReserveMenuHistory';
import ReserveMenuModel from '../components/internal/reserveMenu/ReserveMenuModel';

//queuing
import QueuingType from '../components/external/queuing/QueuingType';
import Queuing from '../components/external/queuing/Queuing';
import QueuingList from '../components/external/queuing/QueuingList';
import QueuingSetting from '../components/external/queuing/QueuingSetting';
import AliVoice from '../components/external/queuing/AliVoice';
import QueuingMemos from '../components/external/queuing/QueuingMemos';
import QueuingAnalysis from '../components/external/queuing/QueuingAnalysis';

//Ad
import Ad from '../components/external/ad/Ad';

//Report
import ProductSaleDetail from '../components/internal/menu/ProductSaleDetail';

//menu
const routes_menu = async (licenseList: Array<any>) => {
    const res: RouteObject[] = [
        // 菜品智库管理
        {
            path: await getPageUrl(licenseList, 'menuWarehouseCategory'),
            element: <MenuWarehouseCategory></MenuWarehouseCategory>
        },
        {
            path: await getPageUrl(licenseList, 'menuWarehouseType'),
            element: <MenuWarehouseType></MenuWarehouseType>
        },
        {
            path: await getPageUrl(licenseList, 'menuWarehouseDepartment'),
            element: <MenuWarehouseDepartment></MenuWarehouseDepartment>
        },
        {
            path: await getPageUrl(licenseList, 'menuWarehouse'),
            element: <MenuWarehouse></MenuWarehouse>
        },
        {
            path: await getPageUrl(licenseList, 'scene'),
            element: <Scene></Scene>
        },
        {
            path: await getPageUrl(licenseList, 'menuMovie'),
            element: <MenuMovie></MenuMovie>
        },
        {
            path: await getPageUrl(licenseList, 'expandCategory'),
            element: <ExpandCategory></ExpandCategory>
        },
        {
            path: await getPageUrl(licenseList, 'expandType'),
            element: <ExpandType></ExpandType>
        },
        {
            path: await getPageUrl(licenseList, 'expandDetail'),
            element: <ExpandDetail></ExpandDetail>
        },

        // 各种报表
        {
            path: await getPageUrl(licenseList, 'productSaleDetail'),
            element: <ProductSaleDetail></ProductSaleDetail>
        },

        //财务
        {
            path: await getPageUrl(licenseList, 'internalStatisticsCategory'),
            element: <InternalStatisticsCategory></InternalStatisticsCategory>
        },
        {
            path: await getPageUrl(licenseList, 'internalStatisticsType'),
            element: <InternalStatisticsType></InternalStatisticsType>
        },
        {
            path: await getPageUrl(licenseList, 'internalStatisticsSetting'),
            element: <InternalStatisticsSetting></InternalStatisticsSetting>
        },

        // 文章管理
        {
            path: await getPageUrl(licenseList, 'menuWarehouseArticleCategory'),
            element: <MenuWarehouseArticleCategory></MenuWarehouseArticleCategory>
        },
        {
            path: await getPageUrl(licenseList, 'menuWarehouseArticleType'),
            element: <MenuWarehouseArticleType></MenuWarehouseArticleType>
        },
        {
            path: await getPageUrl(licenseList, 'menuWarehouseArticle'),
            element: <MenuWarehouseArticle></MenuWarehouseArticle>
        },
        
        // 门店菜式管理
        {
            path: await getPageUrl(licenseList, 'branchStoreMenuWarehouse'),
            element: <BranchStoreMenuWarehouse></BranchStoreMenuWarehouse>
        },

        // 
        {
            path: await getPageUrl(licenseList, 'deptPrintDetail'),
            element: <DeptPrintDetail></DeptPrintDetail>
        },

        // 菜式属性管理
        {
            path: await getPageUrl(licenseList, 'cookMethod'),
            element: <CookMethod></CookMethod>
        },
        {
            path: await getPageUrl(licenseList, 'menuMemo'),
            element: <MenuMemo></MenuMemo>
        },
        {
            path: await getPageUrl(licenseList, 'menuCondiment'),
            element: <MenuCondiment></MenuCondiment>
        },
        {
            path: await getPageUrl(licenseList, 'condimentWarehouse'),
            element: <CondimentWarehouse></CondimentWarehouse>
        },
        {
            path: await getPageUrl(licenseList, 'menuLabel'),
            element: <MenuLabel></MenuLabel>
        },

        // 各店菜谱管理
        {
            path: await getPageUrl(licenseList, 'ingredientWarning'),
            element: <IngredientWarning></IngredientWarning>
        },
        {
            path: await getPageUrl(licenseList, 'dimSumHistory'),
            element: <DimSumHistory></DimSumHistory>
        },
        {
            path: await getPageUrl(licenseList, 'menuBinding'),
            element: <MenuBinding></MenuBinding>
        },
        {
            path: await getPageUrl(licenseList, 'shopCategory'),
            element: <ShopCategory></ShopCategory>
        },
        {
            path: await getPageUrl(licenseList, 'shopType'),
            element: <ShopType></ShopType>
        },
        {
            path: await getPageUrl(licenseList, 'menuHead'),
            element: <MenuHead></MenuHead>
        },
        {
            path: await getPageUrl(licenseList, 'menuHeadCode'),
            element: <MenuHeadCode></MenuHeadCode>
        },
        {
            path: await getPageUrl(licenseList, 'menuOPLog'),
            element: <MenuOPLog></MenuOPLog>
        },
        {
            path: await getPageUrl(licenseList, 'promoCategory'),
            element: <PromoCategory></PromoCategory>
        },
        {
            path: await getPageUrl(licenseList, 'menuSaleDate'),
            element: <MenuSaleDate></MenuSaleDate>
        },
        {
            path: await getPageUrl(licenseList, 'menuSalePeriod'),
            element: <MenuSalePeriod></MenuSalePeriod>
        },
        {
            path: await getPageUrl(licenseList, 'menuSaleTime'),
            element: <MenuSaleTime></MenuSaleTime>
        },
        {
            path: await getPageUrl(licenseList, 'menuSalesman'),
            element: <MenuSalesman></MenuSalesman>
        },
        {
            path: await getPageUrl(licenseList, 'icon'),
            element: <Icon></Icon>
        },
        {
            path: await getPageUrl(licenseList, 'MenuIcon'),
            element: <MenuIcon></MenuIcon>
        },
        {
            path: await getPageUrl(licenseList, 'menuHoliday'),
            element: <MenuHoliday></MenuHoliday>
        },

        // Inventory
        {
            path: await getPageUrl(licenseList, 'menuInventory'),
            element: <MenuSpecInventory></MenuSpecInventory>
        },
        {
            path: await getPageUrl(licenseList, 'menuSpeSpecInventory'),
            element: <MenuSpeSpecInventory></MenuSpeSpecInventory>
        },
        {
            path: await getPageUrl(licenseList, 'condimentInventory'),
            element: <CondimentInventory></CondimentInventory>
        },
        {
            path: await getPageUrl(licenseList, 'menuImSpecInventory'),
            element: <MenuImSpecInventory></MenuImSpecInventory>
        },
        {
            path: await getPageUrl(licenseList, 'imMenuSpeSpecInventory'),
            element: <ImMenuSpeSpecInventory></ImMenuSpeSpecInventory>
        },
        {
            path: await getPageUrl(licenseList, 'imCondimentInventory'),
            element: <ImCondimentInventory></ImCondimentInventory>
        },

        // 预定菜单管理
        {
            path: await getPageUrl(licenseList, 'reserveMenuCategory'),
            element: <ReserveMenuCategory></ReserveMenuCategory>
        },
        {
            path: await getPageUrl(licenseList, 'reserveMenu'),
            element: <ReserveMenu></ReserveMenu>
        },
        {
            path: await getPageUrl(licenseList, 'reserveMenuModel'),
            element: <ReserveMenuModel></ReserveMenuModel>
        },
        {
            path: await getPageUrl(licenseList, 'reserveMenuHistory'),
            element: <ReserveMenuHistory></ReserveMenuHistory>
        },

        // 福食管理
        {
            path: await getPageUrl(licenseList, 'feastTeamMenuWarehouse'),
            element: <FeastTeamMenuWarehouse></FeastTeamMenuWarehouse>
        },
        {
            path: await getPageUrl(licenseList, 'feastTeamMenuWarehouseCategory'),
            element: <FeastTeamMenuWarehouseCategory></FeastTeamMenuWarehouseCategory>
        },
        {
            path: await getPageUrl(licenseList, 'feastTeamMenuHead'),
            element: <FeastTeamMenuHead></FeastTeamMenuHead>
        },

        // 点餐订单管理
        {
            path: await getPageUrl(licenseList, 'menuShoppingCart'),
            element: <MenuShoppingCart></MenuShoppingCart>
        },

        // 排队管理
        {
            path: await getPageUrl(licenseList, 'queuingType'),
            element: <QueuingType></QueuingType>
        },
        {
            path: await getPageUrl(licenseList, 'queuing'),
            element: <Queuing></Queuing>
        },
        {
            path: await getPageUrl(licenseList, 'queuingList'),
            element: <QueuingList></QueuingList>
        },
        {
            path: await getPageUrl(licenseList, 'queuingSetting'),
            element: <QueuingSetting></QueuingSetting>
        },
        {
            path: await getPageUrl(licenseList, 'aliVoice'),
            element: <AliVoice></AliVoice>
        },
        {
            path: await getPageUrl(licenseList, 'queuingMemos'),
            element: <QueuingMemos></QueuingMemos>
        },
        {
            path: await getPageUrl(licenseList, 'queuingAnalysis'),
            element: <QueuingAnalysis></QueuingAnalysis>
        },

        // 广告管理
        {
            path: await getPageUrl(licenseList, 'ad'),
            element: <Ad></Ad>
        },
    ]
    return res;
};

export default routes_menu